export const H5_AUTH_TOKEN_STORAGE_KEY = 'banana.h5.auth.token'
export const H5_AUTH_EXPIRES_STORAGE_KEY = 'banana.h5.auth.expiresAt'
export const H5_AUTH_USER_STORAGE_KEY = 'banana.h5.auth.user'

const AUTH_CHANGED_EVENT = 'banana-h5-auth-changed'
const AUTH_REQUIRED_EVENT = 'banana-h5-auth-required'

function canUseStorage() {
  return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined'
}

function safeParseJson(value, fallback = null) {
  try {
    return value ? JSON.parse(value) : fallback
  } catch (_) {
    return fallback
  }
}

export function getH5Token() {
  if (!canUseStorage()) return ''
  return window.localStorage.getItem(H5_AUTH_TOKEN_STORAGE_KEY) || ''
}

export function getH5ExpiresAt() {
  if (!canUseStorage()) return ''
  return window.localStorage.getItem(H5_AUTH_EXPIRES_STORAGE_KEY) || ''
}

export function getStoredH5User() {
  if (!canUseStorage()) return null
  return safeParseJson(window.localStorage.getItem(H5_AUTH_USER_STORAGE_KEY), null)
}

export function isH5LoggedIn() {
  return Boolean(getH5Token())
}

export function saveH5Session(input = {}) {
  if (!canUseStorage()) return
  const token = String(input.token || '').trim()
  const expiresAt = String(input.expiresAt || '').trim()
  if (token) {
    window.localStorage.setItem(H5_AUTH_TOKEN_STORAGE_KEY, token)
  }
  if (expiresAt) {
    window.localStorage.setItem(H5_AUTH_EXPIRES_STORAGE_KEY, expiresAt)
  }
  if (input.user) {
    window.localStorage.setItem(H5_AUTH_USER_STORAGE_KEY, JSON.stringify(input.user))
  }
  notifyH5AuthChanged()
}

export function saveH5User(user) {
  if (!canUseStorage()) return
  if (user) {
    window.localStorage.setItem(H5_AUTH_USER_STORAGE_KEY, JSON.stringify(user))
  } else {
    window.localStorage.removeItem(H5_AUTH_USER_STORAGE_KEY)
  }
  notifyH5AuthChanged()
}

export function clearH5Session() {
  if (!canUseStorage()) return
  window.localStorage.removeItem(H5_AUTH_TOKEN_STORAGE_KEY)
  window.localStorage.removeItem(H5_AUTH_EXPIRES_STORAGE_KEY)
  window.localStorage.removeItem(H5_AUTH_USER_STORAGE_KEY)
  notifyH5AuthChanged()
}

export function notifyH5AuthChanged() {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(AUTH_CHANGED_EVENT))
}

export function onH5AuthChanged(callback) {
  if (typeof window === 'undefined' || typeof callback !== 'function') {
    return () => {}
  }
  window.addEventListener(AUTH_CHANGED_EVENT, callback)
  window.addEventListener('storage', callback)
  return () => {
    window.removeEventListener(AUTH_CHANGED_EVENT, callback)
    window.removeEventListener('storage', callback)
  }
}

export function notifyH5AuthRequired(redirect = '') {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(AUTH_REQUIRED_EVENT, {
    detail: {
      redirect,
    },
  }))
}

export function onH5AuthRequired(callback) {
  if (typeof window === 'undefined' || typeof callback !== 'function') {
    return () => {}
  }
  window.addEventListener(AUTH_REQUIRED_EVENT, callback)
  return () => {
    window.removeEventListener(AUTH_REQUIRED_EVENT, callback)
  }
}
